import { Close } from '@mui/icons-material'
import { Box, Button, CircularProgress, Grid, Modal } from '@mui/material'
import { useAlert } from 'contexts/alert'
import { useProject } from 'contexts/project'
import dayjs from 'dayjs'
import { useState } from 'react'
import { useHistory } from 'react-router-dom'
import api from 'services/api'
import { formatCNPJ } from 'utils/is-valid-cnpj'
import { useStyles } from './styles'

interface IModalAprovation {
  open: boolean
  onClose: () => void
  templateAppId: string
}

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  height: 'auto',
  minHeight: '367px',
  maxHeight: '800px',
  width: '100%',
  maxWidth: 500,
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: '0.35rem',
  border: 'none',
  outline: 'none',
  padding: '1rem 1.5rem',
}

const ModalAprovation: React.FC<IModalAprovation> = ({ open, onClose, templateAppId }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const { data: project } = useProject()
  const { openAlert } = useAlert()

  const classes = useStyles()
  const history = useHistory()

  const app = project?.recipes.find((recipe) => recipe.id === templateAppId)

  const handleClose = () => onClose()

  const handleSelectOption = async () => {
    try {
      setIsLoading(true)

      const body = {
        projectId: project?.id,
        tableName: project?.entryTables[0].key,
        appId: app?.appId,
      }

      await api.post('conducco-cdp-approvals', body)
      openAlert('Aprovação realizada com sucesso', 'success')
    } catch (error) {
      openAlert('Houve algum error na aprovação', 'error')
    } finally {
      setIsLoading(false)
      onClose()
    }
  }

  const handleVisualizeTable = () => {
    history.push(`/projects/table/${project?.id}/${project?.entryTables[0].id}`)
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <Box sx={style}>
        <Box className={classes.header}>
          <h6>Aprovação</h6>
          <Close
            className={classes.closeBtn}
            onClick={handleClose}
          />
        </Box>
        <Box className={classes.container}>
          <Box className={classes.title}>
            <span>
              Gostaria de visualizar a <strong>massa elegível</strong> antes de aprovar?
              <p onClick={handleVisualizeTable}>Clique aqui.</p>
            </span>
          </Box>

          <Grid
            container
            spacing={2}
          >
            <Grid
              item
              xs={6}
            >
              <Box className={classes.item}>
                <p>{project.organizationRequest.corporateName}</p>
                <span>{formatCNPJ(project.organizationRequest.federalTaxId, false)}</span>
              </Box>
            </Grid>
            <Grid
              item
              xs={6}
            >
              <Box className={classes.item}>
                <p>{project.organizationOutput.corporateName}</p>
                <span>{formatCNPJ(project.organizationOutput.federalTaxId, false)}</span>
              </Box>
            </Grid>
            <Grid
              item
              xs={6}
            >
              <Box className={classes.item}>
                <p>Operador</p>
                <span>Bradesco Seguros</span>
              </Box>
            </Grid>
            <Grid
              item
              xs={6}
            >
              <Box className={classes.item}>
                <p>Data de aprovação</p>
                <span>{dayjs(new Date()).format('DD/MM/YYYY')}</span>
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Box className={classes.actions}>
          <Button
            type='button'
            variant='outlined'
            disabled={isLoading}
            className={classes.cancelButton}
            onClick={handleClose}
          >
            Cancelar
          </Button>
          <Button
            type='button'
            variant='contained'
            size='small'
            disabled={isLoading}
            className={classes.submitButton}
            onClick={handleSelectOption}
          >
            {isLoading ? (
              <CircularProgress
                color='inherit'
                size={15}
              />
            ) : (
              'Aprovar'
            )}
          </Button>
        </Box>
      </Box>
    </Modal>
  )
}

export default ModalAprovation
